import { render } from "./StackItem.vue?vue&type=template&id=5ca444f4"
import script from "./StackItem.vue?vue&type=script&lang=js"
export * from "./StackItem.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./StackItem.vue?vue&type=style&index=0&id=5ca444f4&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__